/**
 * Onboarding Store Module
 *
 * 2025-05-28: Created onboarding state management with step tracking (local state only)
 */

const state = {
  currentStep: 1,
  totalSteps: 3,
  completedSteps: [],
  stepData: {
    import: {
      isComplete: false,
      data: {},
    },
    automation: {
      isComplete: false,
      data: {},
    },
    ai: {
      isComplete: false,
      data: {},
    },
  },
}

const getters = {
  getCurrentStep: state => state.currentStep,
  getTotalSteps: state => state.totalSteps,
  getCompletedSteps: state => state.completedSteps,
  isStepComplete: state => stepNumber => {
    return state.completedSteps.includes(stepNumber)
  },
  canProceedToStep: (state, getters) => stepNumber => {
    if (stepNumber === 1) return true
    return getters.isStepComplete(stepNumber - 1)
  },
  getStepData: state => stepName => {
    return state.stepData[stepName] || {}
  },
  isOnboardingComplete: state => {
    return state.completedSteps.length === state.totalSteps
  },
  progressPercentage: state => {
    return Math.round((state.completedSteps.length / state.totalSteps) * 100)
  },
}

const mutations = {
  SET_CURRENT_STEP(state, step) {
    state.currentStep = step
  },

  MARK_STEP_COMPLETE(state, step) {
    if (!state.completedSteps.includes(step)) {
      state.completedSteps.push(step)
    }
  },

  SET_COMPLETED_STEPS(state, steps) {
    state.completedSteps = steps
  },

  SET_STEP_DATA(state, { stepName, data }) {
    if (state.stepData[stepName]) {
      state.stepData[stepName].data = data
      state.stepData[stepName].isComplete = true
    }
  },

  RESET_ONBOARDING(state) {
    state.currentStep = 1
    state.completedSteps = []
    Object.keys(state.stepData).forEach(step => {
      state.stepData[step].isComplete = false
      state.stepData[step].data = {}
    })
  },
}

const actions = {
  setCurrentStep({ commit }, step) {
    commit('SET_CURRENT_STEP', step)
  },

  completeStep({ commit, state }, { step, data = {} }) {
    // Mark the step as complete
    commit('MARK_STEP_COMPLETE', step)

    // Store step data based on step number
    let stepName
    switch (step) {
      case 1:
        stepName = 'import'
        break
      case 2:
        stepName = 'automation'
        break
      case 3:
        stepName = 'ai'
        break
      default:
        return
    }

    commit('SET_STEP_DATA', { stepName, data })

    // Auto-advance to next step if not at the end
    if (step < state.totalSteps) {
      commit('SET_CURRENT_STEP', step + 1)
    }
  },

  goToStep({ commit, getters }, step) {
    if (getters.canProceedToStep(step)) {
      commit('SET_CURRENT_STEP', step)
    }
  },

  resetOnboarding({ commit }) {
    commit('RESET_ONBOARDING')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
